import React from 'react';
import { Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { museoSansFont700 } from 'util/EnumHelper';
import colorConstants from "styles/ColorConstants";
import { localize } from 'util/Localizer';
import StyledAccordion from 'components/Common/StyledAccordion/StyledAccordion';
import Auth from 'auth/Auth';
import HowToGrantAppAccess from './HowTos/HowToGrantAppAccess';
import HowToViewRouteDetail from './HowTos/HowToViewRouteDetail';

const StyledH3 = styled(Typography)(() => ({
    color: colorConstants.EVERDRIVENDARKCHARCOAL,
    fontFamily: museoSansFont700,
    fontSize: 24,
    margin: 0
}));

function Sidebar({ isRouteOpen }) {
    const teacherAppEnabled = Auth.getConfig().teacherAppEnabled !== null ?
        Auth.getConfig().teacherAppEnabled : true;

    return (
        <Paper data-testid="HowTos"
            sx={{
                p: '32px',
                borderRadius: '8px'
            }}
        >
            <StyledH3>{localize('resources.howto')}</StyledH3>
            { teacherAppEnabled && <StyledAccordion title={localize('resources.AppAccessToStaff')}>
                <HowToGrantAppAccess />
            </StyledAccordion> }
            <StyledAccordion title={localize('resources.ViewRouteDetails')} isDefaultOpen={isRouteOpen}>
                <HowToViewRouteDetail />
            </StyledAccordion>
        </Paper>
    );
}

Sidebar.defaultProps = {
    isRouteOpen: false
};

Sidebar.propTypes = {
    isRouteOpen: PropTypes.bool
};

export default Sidebar;
